import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, inject, watch, Ref } from 'vue';
import CButton from '@/components/shared/CButton';
import ImageEffectsPropertiesModalsEdit from '@/components/DesignStudio/ImageEffectsProperties/components/list/item/edit/ImageEffectsPropertiesListItemEdit.vue';
import { IMAGE_EFFECT_PRESETS, PRESET_CATEGORIES } from '@/components/DesignStudio/ImageEffectsProperties/core/presets';
import { upgradeSavedImageEffect } from '@/components/DesignStudio/ImageEffectsProperties/utils/savedImageEffects';

import { ImageEffectType, EditableEffectTypes } from '@/typings/customilyElements/imageEffectType';
import store from '@/store';

interface Props {
    id: number;
    item: ImageEffectType;
    readonly?: boolean;
    pinned?: boolean;
}

interface Emits {
    (event: 'update', value: ImageEffectType): void;
    (event: 'remove', value: ImageEffectType): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesListItem',
  props: {
    id: null,
    item: null,
    readonly: { type: Boolean },
    pinned: { type: Boolean }
  },
  emits: ["update", "remove"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update', value: ImageEffectType): void;
    (event: 'remove', value: ImageEffectType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id: number;
    item: ImageEffectType;
    readonly?: boolean;
    pinned?: boolean;
};




const isOpen = ref(false);

const openEffectId = inject<Ref<string | null>>('openEffectId', ref(null));

watch(
    () => openEffectId?.value,
    (val) => {
        if (val && val === props.item.id) {
            handleOpen();
            openEffectId!.value = null;
        }
    }
);

const effectInfo = computed(() => IMAGE_EFFECT_PRESETS.find((preset) => preset.id === props.item.presetId));
const isEditable = computed(() => EditableEffectTypes.includes(props.item.type));

const icon = computed(() => {
    const categoryFound = PRESET_CATEGORIES.find(
        (presetCategory) => presetCategory.category === effectInfo?.value?.category
    );
    return categoryFound?.icon;
});

const handleClose = () => {
    isOpen.value = false;
};

const handleOpen = () => {
    store?.dispatch('imageEffectsProperties/openAddModal');
    const effect = {
        thumbnail: effectInfo.value?.thumbnail,
        label: effectInfo.value?.label,
        tags: effectInfo.value?.tags,
        type: effectInfo.value?.effectConfig.type,
        formData: upgradeSavedImageEffect(props.item),
        isFree: effectInfo.value?.isFree
    };
    store?.dispatch('imageEffectsProperties/selectImageEffect', effect);
};

const handleUpdate = (item: ImageEffectType) => {
    emit('update', item);
};

const handleRemove = () => {
    emit('remove', props.item);
};

return { __sfc: true,props, emit, isOpen, openEffectId, effectInfo, isEditable, icon, handleClose, handleOpen, handleUpdate, handleRemove, CButton, ImageEffectsPropertiesModalsEdit }
}

})